import React, { Component }  from 'react';
import { Button, Radio, RadioGroup, Dialog, DialogActions, DialogContent, FormControlLabel, DialogTitle } from '@material-ui/core';
import { useTranslation, Trans } from 'react-i18next';
const { t } = useTranslation();

class StartModal extends Component {
    enterPressed(event) {
        var code = event.keyCode || event.which;
        if(code === 13) { 
            this.props.startOrderStep();
        } 
    }

    render() {
        return <Dialog open={this.props.visible} onClose={this.handleCloseStartDialog} aria-labelledby="form-dialog-title">
        <DialogTitle id="form-dialog-title"><Trans>{t('StartModalTitle')}</Trans></DialogTitle>
        <DialogContent>
        <RadioGroup
                        aria-label="gender"
                        name="gender1"
                        value={this.props.tracing}
                        onChange={this.props.handleChangeTracing}
                        onKeyPress={this.enterPressed.bind(this)}
                        >
                        <FormControlLabel value={"1"} control={<Radio />} label={<Trans>{t('BatchLevel')}</Trans>} />
                        <FormControlLabel value={"2"} control={<Radio />} label={<Trans>{t('PartLevel')}</Trans>} />
                        </RadioGroup>
        </DialogContent>
        <DialogActions>
            <Button variant="contained" color="secondary" onClick={this.props.startOrderStep}>
                <Trans>{t('Ok')}</Trans>
            </Button>
            <Button variant="contained" color="secondary" onClick={this.props.handleStartModalCancel}>
                <Trans>{t('Cancel')}</Trans>
            </Button>
        </DialogActions>
    </Dialog>
    }
}

export default StartModal;